<template>
  <div>
    <v-dialog
      :value="show"
      persistent
      lazy
      :width="$store.state.common.mediumDialogWidth"
      @input="(val) => $emit('update:show', val)"
    >
      <v-card>
        <v-card-title class="pb-0 d-block">
          <v-layout align-center>
            <v-layout
              align-center
              wrap
            >
              <div class="headline mb-2">
                {{ $t('menuItemsDuplicateDialogTitle') }}
              </div>
            </v-layout>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              :title="$t('close')"
              @click="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text v-if="payload">
          <!-- Category -->
          <v-select
            v-model="payload.category"
            :label="$t('menuCategory')"
            item-text="name"
            item-value="id"
            return-object
            :items="orderedMenuCategories"
          />
          <!-- Name -->
          <v-form
            ref="name-form"
            @submit.prevent
          >
            <v-text-field
              ref="name-input"
              v-model="payload.name"
              :label="$t('name')"
              counter="128"
              @keyup.enter="formIsValid ? save() : null"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            round
            flat
            color="msr"
            class="ml-auto"
            :disabled="!formIsValid"
            @click="save()"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import orderBy from 'lodash.orderby';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    menuItemToDuplicate: {
      type: Object,
      required: true,
    },
    menuCategories: {
      type: Array[Object],
      required: true,
    },
    menuItems: {
      type: Array[Object],
      required: true,
    },
  },
  data() {
    return {
      payload: null,
    };
  },
  computed: {
    orderedMenuCategories() {
      return orderBy(this.menuCategories, 'name');
    },
    formIsValid() {
      if (!this.payload) {
        return false;
      }
      return (
        // Name must not be empty
        !!this.payload.name &&
        this.payload.name.trim() != '' &&
        // Category
        !!this.payload.category &&
        // Price
        this.payload.price != ''
      );
    },
  },
  watch: {
    show: function (show) {
      if (show) {
        this.initialize();
        this.$nextTick(() => {
          this.$refs['name-input'].focus();
        });
      }
    },
    'payload.name': function () {
      this.validateNameForm();
    },
    'payload.category': function () {
      this.validateNameForm();
    },
  },
  methods: {
    validateNameForm() {
      this.$nextTick(() => {
        this.$refs['name-form'].validate();
      });
    },
    initialize() {
      this.payload = Object.assign({}, this.menuItemToDuplicate);
      this.payload.name = this.payload.name;
    },
    close() {
      this.$emit('update:show', false);
    },
    save() {
      if (!this.formIsValid) {
        return;
      }
      this.$emit('save', this.payload);
      this.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Menu/DuplicateMenuItemDialog.vue